"use strict";
const notification = require("./notification");

const Common = (function () {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  return {
    isMobile,
    init: function () {
      
    }
  };
})();

module.exports = Common;
